import { APP_ENV } from '@env';
import { Box, Pressable, Text } from 'native-base';
import React from 'react';
import { useAppSelector } from '../../store';

interface TestModeBannerProps {
  onPress: () => void;
}

const TestModeBanner: React.FC<TestModeBannerProps> = ({ onPress }) => {
  const testDate = useAppSelector((state) => state.testContext.testDate);

  if (APP_ENV === 'production' || !testDate) return null;

  const formattedDate = new Date(testDate).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <Pressable onPress={onPress}>
      <Box bg="amber.400" px={4} py={2} alignItems="center">
        <Text fontSize={12} fontWeight="bold" color="amber.900">
          TEST MODE: {formattedDate}
        </Text>
      </Box>
    </Pressable>
  );
};

export default TestModeBanner;
